<div class="row">
  <div class="col-xs-10">
    <app-question-edit></app-question-edit>
    <hr>
    <ul class="list-group">
      <a
        class="list-group-item"
        style="cursor: pointer"
        *ngFor="let question of (questionListState | async).questions; let i = index"
        (click)="onEditItem(i)"
      >
        {{ question.name }}
        ({{ question.type }})
        {{ question.text }}
      </a>
    </ul>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/question-list/question-list.component.html